class MwError extends Error {
    constructor({message, code, details = {}}) {
        super(message);
        this.name = 'MwError';
        this.code = code;
        this.details = details;
    }
}

export {MwError};
